<template>
    <div>
        <!-- <section class="inner_banner">

        </section> -->

        <section class="deposite_wrapp">
            <div class="container">
                <h2>Deposit</h2>
                <p>Deposit Stablecoins to the StableSwitch liquidity pools and earn a percentage of the platform Switch fees.</p>
                <p>Stable Switch allows you to select the coins you want to receive when you withdraw your Stable coin collateral. This can be fixed to the coin you have depo sited - or to increase earning rates you can select more stablecoins.</p>
                <p>Select the coin you wish to deposit, followed by the Stable coins you are happy to receive to present the historic earnings for the last 30 days. </p>
                <div class="deposite_table">
                    <div class="table-responsive">
                        <table>
                            <thead>
                            <tr>
                                <th>Liquidity pool</th>
                                <th>Current Platform fee</th>
                                <th>last 30 day APR</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for="item in deposits">
                                <tr :key="item.id">
                                    <td colspan="3" class="dropdown_main" :class="{current:item.id === current}" @click="open(item.id)" :data-id="item.id" v-click-outside="close">
                                        <img :src="item.logo" alt=""><span>{{ item.name }}</span>
                                        <div class="dropdown_content">
                                            <h4>USDT</h4>
                                            <div class="quantity">
                                                <input type="text" class="form-control" placeholder="Add Quantity">
                                            </div>
                                            <div class="accept">
                                                <div class="cc-selector">
                                                    <h5>Coins I’m willing to accept</h5>
                                                    <input id="selector5" type="radio" name="currancy2" value="selector5"/>
                                                    <label class="drinkcard-cc icon1" for="selector5"></label>
                                                    <input id="selector6" type="radio" name="currancy2" value="selector6"/>
                                                    <label class="drinkcard-cc icon2" for="selector6"></label>
                                                    <input id="selector7" type="radio" name="currancy2" value="selector7"/>
                                                    <label class="drinkcard-cc icon3" for="selector7"></label>
                                                    <input id="selector8" type="radio" name="currancy2" value="selector8"/>
                                                    <label class="drinkcard-cc icon4" for="selector8"></label>
                                                </div>
                                            </div>
                                            <div class="liquidity">
                                                <input type="text" class="form-control" placeholder="Current pool liquidity ">
                                            </div>
                                            <p>Deposit APY based on the last 30 days </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-for="percent in item.percents" :key="`${item.id}-4-${percent.id}`" class="inner_main">
                                    <td><img :src="item.logo" alt="">USDC >
                                        <img :src="getItem(percent.id).logo" alt="">{{ getItem(percent.id).name }}
                                    </td>
                                    <td>
                                        <div v-if="percent.percent1">{{ percent.percent1 }}%</div>
                                    </td>
                                    <td>{{ percent.percent2 }}%</td>
                                </tr>
                                <tr :key="`${item.id}-4`" class="border-t-b">
                                    <td colspan="2"><b>Total APR (based on the last 30 days)</b></td>
                                    <td><b>{{ item.total }}%</b></td>
                                </tr>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: 'Deposite',
    data () {
        return {
            deposits: [
                {
                    id: 1,
                    name: 'USDC',
                    logo: require('../assets/images/USDC.png'),
                    total: 7,
                    percents: [
                        {
                            id: 2,
                            percent2: 1
                        },
                        {
                            id: 3,
                            percent1: .5,
                            percent2: 2.3
                        },
                        {
                            id: 4,
                            percent2: 3.2
                        }
                    ]
                },
                {
                    id: 2,
                    name: 'USDT',
                    logo: require('../assets/images/USDT.png'),
                    total: 7,
                    percents: [
                        {
                            id: 2,
                            percent2: 1
                        },
                        {
                            id: 3,
                            percent1: .5,
                            percent2: 2.3
                        },
                        {
                            id: 4,
                            percent2: 3.2
                        }
                    ]
                },
                // {
                //     id: 3,
                //     name: 'PAX',
                //     logo: require('../assets/images/PAX.png'),
                //     total: 7,
                //     percents: [
                //         {
                //             id: 2,
                //             percent2: 1
                //         },
                //         {
                //             id: 3,
                //             percent1: .5,
                //             percent2: 2.3
                //         },
                //         {
                //             id: 4,
                //             percent2: 3.2
                //         }
                //     ]
                // },
                // {
                //     id: 4,
                //     name: 'BUSD',
                //     logo: require('../assets/images/BUSD.png'),
                //     total: 7,
                //     percents: [
                //         {
                //             id: 2,
                //             percent2: 1
                //         },
                //         {
                //             id: 3,
                //             percent1: .5,
                //             percent2: 2.3
                //         },
                //         {
                //             id: 4,
                //             percent2: 3.2
                //         }
                //     ]
                // }
            ],
            current: null
        }
    },
    methods: {
        getItem (_id) {
            return this.deposits.find(({ id }) => id === _id) || {}
        },
        open (id) {
            this.current = id
        },
        close (e, vnode) {
            if (this.current && vnode.elm.dataset.id === this.current.toString()) {
                this.current = null
            }
        }
    }
}
</script>

<style scoped>

</style>
